import { render } from "./dashboard.vue?vue&type=template&id=8f9172a8"
import script from "./dashboard.vue?vue&type=script&lang=ts"
export * from "./dashboard.vue?vue&type=script&lang=ts"
script.render = render

export default script